import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { FormDataService } from './form-data.service';

@Injectable({
    providedIn: 'root'
})
export class FormSubmitService {

    formData: any;

    headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    private baseUrl = environment.apiBaseUrl;
    private companyRoute = '/company'; 
    private busTypes = '/companyBusinessType';
    private contracts = '/companyContract';
    private contractDetails = '/companyContractDetails';
    private directors = '/companydirector';
    private docsRoute = '/companydocument';
    private hseRoute = '/companyHSE';
    private signatories = '/companysignatory';
    private subcontracts = '/companysubcontract';
    private subsidaries = '/companysubsidary';
    private user = '/user'
    // private user = '/v1/auth'

    constructor(private http: HttpClient, private formDataService: FormDataService) {
    }

    //COMPANY
    submitCompany(): Observable<any> {
        const formData = this.formDataService.getFormData();

        // const mailingCountry = this.formDataService.getCountryMailing();
        // const registeredCountry = this.formDataService.getCountryRegistered();
        // const affiliatedSubsidary = this.formDataService.getAffiliatedSubsidary();

        // if (mailingCountry) {
        //     formData.company.strMailingAddress += `, ${mailingCountry}`;
        // }
    
        // if (registeredCountry) {
        //     formData.company.strRegisteredAddress += `, ${registeredCountry}`;
        // }

        // if (affiliatedSubsidary) {
        //     formData.company.strAffiliation += `[${affiliatedSubsidary}]`
        // }

        return this.http.post(`${this.baseUrl + this.companyRoute}/save`, formData.company, { headers: this.headers });
    }

    //BUSINESS TYPE
    submitBusinessTypes(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        const payload = {
            companyId: companyId, 
            companyBusTypes: formData.companyBusTypes
        };
        // console.log("Payload: " + JSON.stringify(payload, null, 2));
        return this.http.post(`${this.baseUrl + this.busTypes}/save`, payload, { headers: this.headers, responseType: 'text' as const });
    }

    //COMPANY CONTRACTS 
    submitCompanyContracts(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        const topCustPayload = {
            companyId: companyId, 
            topCustomers: formData.topcustomers,
        }

        console.log("company contracts: ", topCustPayload);
        return this.http.post(`${this.baseUrl + this.contracts}/save`, topCustPayload, { headers: this.headers, responseType: 'text' as const });
    }

    //CONTRACT DETAILS
    submitContractDetails(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        const contractDetailsPayload = {
            companyId: companyId, 
            blnAllowsSubcontracts: formData.getDoesSubcontract,
            blnContractStatus: formData.getblnContractStatus,
            strContractDetails: formData.getstrContractDetails
        };
        return this.http.post(`${this.baseUrl + this.contractDetails}/save`, contractDetailsPayload, { headers: this.headers, responseType: 'text' as const });
    }

    //COMPANY DIRECTOR 
    submitDirector(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        const directorPayload = {
            companyId: companyId, 
            data: formData.directors
        }
        
        // console.log("Payload: " + JSON.stringify(directorPayload, null, 2));

        return this.http.post(
            `${this.baseUrl + this.directors}/save`,
            directorPayload,
            {
            headers: this.headers,
            responseType: 'text' as const
            }
        ).pipe(
            tap(response => {
            console.log("Director Save Response:", response);
            }),
            catchError(error => {
            console.error("Error saving director:", error);
            return throwError(() => error);
            })
        );
    }

    //DOCUMENTS
    submitDocuments(companyId: number): Observable<any> {
        const formData = this.formDataService.getFormData();

        const docFormData = new FormData();
      
        // Append non-file data
        docFormData.append('intCompanyFK', companyId.toString());
        docFormData.append('hasVatDocument', formData.documents.hasVatDocument);
        docFormData.append('vatRegistrationNo', formData.documents.vatRegistrationNo || '');
        docFormData.append('noVatReason', formData.documents.noVatReason || '');
        docFormData.append('vatExpiryDate', formData.documents.vatExpiryDate || '');
      
        docFormData.append('hasBirDocument', formData.documents.hasBirDocument);
        docFormData.append('birNo', formData.documents.birNo || '');
        docFormData.append('noBirReason', formData.documents.noBirReason || '');
        // docFormData.append('birExpiryDate', formData.documents.birExpiryDate || '');
      
        docFormData.append('hasNibDocument', formData.documents.hasNibDocument);
        docFormData.append('nibNo', formData.documents.nibNo || '');
        docFormData.append('noNibReason', formData.documents.noNibReason || '');
        docFormData.append('nibExpiryDate', formData.documents.nibExpiryDate || '');
      
        docFormData.append('hasIncorporationCertificate', formData.documents.hasIncorporationCertificate);
        docFormData.append('noIncorporationReason', formData.documents.noIncorporationReason || '');
      
        docFormData.append('hasRegistrationCertificate', formData.documents.hasRegistrationCertificate);
        docFormData.append('hasCompanyProfile', formData.documents.hasCompanyProfile);
        docFormData.append('hasGeneralLicenses', formData.documents.hasGeneralLicenses);
        docFormData.append('generalLicensesExpiryDate', formData.documents.generalLicensesExpiryDate || '');
      
        // Append files conditionally
        if (formData.documents.vatFile) {
            docFormData.append('vatFile', formData.documents.vatFile);
        }
        if (formData.documents.birFile) {
            docFormData.append('birFile', formData.documents.birFile);
        }
        if (formData.documents.nibFile) {
            docFormData.append('nibFile', formData.documents.nibFile);
        }
        if (formData.documents.incorpFile) {
            docFormData.append('incorporationFile', formData.documents.incorpFile);
        }
        if (formData.documents.regFile) {
            docFormData.append('registrationFile', formData.documents.regFile);
        }
        if (formData.documents.companyFile) {
            docFormData.append('companyProfileFile', formData.documents.companyFile);
        }
        if (formData.documents.licenseFile) {
            docFormData.append('licenseFile', formData.documents.licenseFile);
        }
        if (formData.documents.tcFile) {
            docFormData.append('tcFile', formData.documents.tcFile);
        }
        if (formData.documents.conductFile) {
            docFormData.append('conductFile', formData.documents.conductFile);
        }
      
        return this.http.post(`${this.baseUrl + this.docsRoute}/upload`, docFormData, { responseType: 'text' as const });
      }
      

    downloadFile(fileName: string) {
        return this.http.get(`${this.baseUrl + this.docsRoute}/download/${fileName}`, { responseType: 'blob' });
    }

    //HSE 
    submitHSE(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();
        const hse = formData.hse_docs ?? {};

        const hseFormData = new FormData();
    
        hseFormData.append('intCompanyFK', companyId);
        hseFormData.append('agreedToSustainabilityChecklist', String(hse.agreedToSustainabilityChecklist === true));

        if (hse.safetyFile) {
            hseFormData.append('safetyFile', hse.safetyFile);
        }
        if (hse.trainingFile) {
            hseFormData.append('trainingFile', hse.trainingFile);
        }
        if (hse.resourcesFile) {
            hseFormData.append('resourcesFile', hse.resourcesFile);
        }
    
        return this.http.post(`${this.baseUrl + this.hseRoute}/save`, hseFormData, { responseType: 'text' as const });
    }
  

    //SIGNATORIES
    submitSignatories(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        const signatoriesPayload = {
            companyId: companyId, 
            data: formData.authsignatories
        }
        return this.http.post(`${this.baseUrl + this.signatories}/save`, signatoriesPayload, { headers: this.headers,  responseType: 'text' as const  });
    }

    //SUBCONTRACTS
    submitSubcontracts(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        const subPayload = {
            companyId: companyId,
            data: Array.isArray(formData.strPrimaryWorkSubContracted)
                ? formData.strPrimaryWorkSubContracted.map((item: any) => 
                    typeof item === "string" ? { strPrimaryWorkSubContracted: item } : item
                  )
                : [{ strPrimaryWorkSubContracted: formData.strPrimaryWorkSubContracted }]
        };

        return this.http.post(`${this.baseUrl + this.subcontracts}/save`, subPayload, { headers: this.headers,  responseType: 'text' as const  });
    }

    //SUBSIDARIES
    submitSubsidaries(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        const subsidariesPayload = {
            companyId: companyId, 
            data: formData.subsidaries
        }
        return this.http.post(`${this.baseUrl + this.subsidaries}/save`, subsidariesPayload, { headers: this.headers,  responseType: 'text' as const  });
    }
   
    //USER
    submitUser(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        const userData = new FormData();
    
        const { signatureFile, ...userWithoutFile } = formData.user;
        const userToSubmit = { ...userWithoutFile, intCompanyFK: companyId };
        
        // console.log(userWithoutFile);
        
        userData.append('user', JSON.stringify(userToSubmit));
    
        if (signatureFile) {
            console.log('Appending signature file:', signatureFile);
            userData.append('signatureFile', signatureFile);
        }
    
        console.log("submitting..", userData)
        console.log("Company ID being passed:", companyId);
        console.log("FormData contents:");
        userData.forEach((value, key) => {
          console.log(key, value);
        
        });

        
        return this.http.post(`${this.baseUrl + this.user}/save`, userData, { 
            responseType: 'text' as const 
          }).pipe(
            catchError((error: HttpErrorResponse) => {
              console.error('User save failed:', error);
          
              // Re-throw the error so components can also catch it
              return throwError(() => error);
            })
          );
          
          
    }
    
    rollbackCompany(companyId: number): Observable<any> {
        return this.http.delete(`${this.baseUrl+ this.companyRoute}/${companyId}`);
      }
      
}
